export default __webpack_public_path__ + "static/media/steam_background.b1407d97.jpg";